import { useState, useEffect } from "react";
import './styles/main.scss';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './routes/AppRoutes';

function App() {
  const [theme, setTheme] = useState("light"); // default

  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved) setTheme(saved);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === "dark" ? "light" : "dark"));
  };
  return (
    <div>
      {/* <Header /> */}
      <Header theme={theme} toggleTheme={toggleTheme} />
      <AppRoutes />
      <Footer />
    </div>
  );
}

export default App;
